export default __webpack_public_path__ + "static/media/section3_2_1.2c432482.png";